import type {z} from "zod";

import {UpdateSupplierBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {supplierFieldLabelIds} from "../../../messages/suppliers.messages";

const company = UpdateSupplierBody.shape.company.shape;
const profile = company.partyProfile.shape;
const phone = profile.phone.shape;

export const updateSupplierFormSchema = zod.object({
  companyId: requiredStringSchema(company.companyId, supplierFieldLabelIds.companyId),
  companyName: requiredStringSchema(company.companyName, supplierFieldLabelIds.companyName),
  address: requiredStringSchema(profile.address.shape.address, supplierFieldLabelIds.address),
  country: profile.country,
  phoneNumber: phone.nationalNumber,
  phonePrefix: phone.regionCode,
  websiteUrl: profile.websiteUrl,
  logoUrl: UpdateSupplierBody.shape.logoUrl,
  status: UpdateSupplierBody.shape.status,
  roles: UpdateSupplierBody.shape.roles,
  standardization: UpdateSupplierBody.shape.standardization,
  deliveryTimeDays: UpdateSupplierBody.shape.deliveryTimeDays,
  paymentTimeDays: UpdateSupplierBody.shape.paymentTimeDays,
});
export type UpdateSupplierFormPayload = z.output<typeof updateSupplierFormSchema>;

export const draftUpdateSupplierFormSchema = updateSupplierFormSchema.partial();
export type DraftUpdateSupplierFormPayload = z.output<typeof draftUpdateSupplierFormSchema>;
